import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const FontMono: React.FC<Props> = ({
  className,
  width = 23,
  height = 15,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.655625 14L5.07563 0.88H6.95563L11.3756 14H9.61563L7.33563 6.66C7.10896 5.92667 6.88229 5.2 6.65563 4.48C6.44229 3.74667 6.23563 3 6.03563 2.24H5.95563C5.74229 3 5.52896 3.74667 5.31563 4.48C5.10229 5.2 4.88229 5.92667 4.65563 6.66L2.35563 14H0.655625ZM2.97563 10V8.66H8.99563V10H2.97563ZM16.9278 14.24C16.3278 14.24 15.7745 14.1333 15.2678 13.92C14.7611 13.6933 14.3611 13.3733 14.0678 12.96C13.7745 12.5467 13.6278 12.0533 13.6278 11.48C13.6278 10.3867 14.1745 9.56 15.2678 9C16.3611 8.42667 18.1611 8.04 20.6678 7.84C20.6545 7.4 20.5611 6.99333 20.3878 6.62C20.2278 6.24667 19.9611 5.95333 19.5878 5.74C19.2145 5.51333 18.7145 5.4 18.0878 5.4C17.6745 5.4 17.2611 5.46 16.8478 5.58C16.4478 5.68667 16.0611 5.83333 15.6878 6.02C15.3278 6.19333 14.9945 6.37333 14.6878 6.56L14.0478 5.44C14.3678 5.22667 14.7545 5.01333 15.2078 4.8C15.6745 4.57333 16.1745 4.39333 16.7078 4.26C17.2411 4.11333 17.7945 4.04 18.3678 4.04C19.2611 4.04 19.9945 4.20667 20.5678 4.54C21.1545 4.87333 21.5878 5.34 21.8678 5.94C22.1611 6.52667 22.3078 7.22667 22.3078 8.04V14H20.9678L20.8278 12.68H20.7678C20.2345 13.1067 19.6345 13.4733 18.9678 13.78C18.3011 14.0867 17.6211 14.24 16.9278 14.24ZM17.3678 12.92C17.9278 12.92 18.4811 12.7933 19.0278 12.54C19.5745 12.2867 20.1211 11.9333 20.6678 11.48V8.92C19.2811 9.04 18.1878 9.20667 17.3878 9.42C16.6011 9.63333 16.0411 9.90667 15.7078 10.24C15.3878 10.56 15.2278 10.9333 15.2278 11.36C15.2278 11.72 15.3278 12.02 15.5278 12.26C15.7278 12.4867 15.9878 12.6533 16.3078 12.76C16.6411 12.8667 16.9945 12.92 17.3678 12.92Z"
        fill="#2F7FEF"
      />
    </svg>
  )
}
